<template>
  <b-card class="card-company-table">
    <b-card-header>
      <h5>{{ title }}</h5>
    </b-card-header>
    <b-table
        :items="tableData"
        responsive
        :fields="fields"
        class="mb-0"
    />
  </b-card>
</template>

<script>
import {
  BCard, BTable, BCardHeader,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BTable,
    BCardHeader,
  },
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: 'گزارشات نامه ها',
    },
  },

  data() {
    return {
      fields: [
        {
          key: 'name',
          label: 'نام',
        },
        {
          key: 'mobile',
          label: 'موبایل',
        },
        {
          key: 'username',
          label: 'نام کاربری',
        },
        {
          key: 'tickets_count',
          label: 'تعداد تیکت',
        },
      ],
    }
  },
  methods: {
    goToTicket(ticketId) {
      this.$router.push(`tickets/${ticketId}`)
    },
  },
}
</script>
